/**
 * Calculates the number of days until the next tax filing deadline.
 *
 * @returns A number of days until the next tax filing deadline.
 */
export const daysUntilTaxDeadline = () => {
  const today = new Date();
  let taxDeadline;

  if (
    today.getMonth() > 3 ||
    (today.getMonth() === 3 && today.getDate() > 15)
  ) {
    // If it's after April 15, tax deadline is on April 15 of next year
    taxDeadline = new Date(today.getFullYear() + 1, 3, 15);
  } else {
    // If it's before or on April 15, tax deadline is on April 15 of this year
    taxDeadline = new Date(today.getFullYear(), 3, 15);
  }

  const oneDay = 1000 * 60 * 60 * 24; // milliseconds in a day
  const diffInMilliseconds = taxDeadline.getTime() - today.getTime();
  const diffInDays = Math.ceil(diffInMilliseconds / oneDay);

  return diffInDays;
};

/**
 * Returns a string representing today's date in the long format
 * (e.g. "Wednesday, March 15, 2023").
 *
 * @returns A string representing today's date.
 */
export const getCurrentDateString = () => {
  const today = new Date();
  const options = {
    weekday: "long" as const,
    year: "numeric" as const,
    month: "long" as const,
    day: "numeric" as const,
  };
  const dateString = today.toLocaleDateString("en-US", options);
  return dateString;
};
